import * as echarts from "echarts";
import {randomPercents} from "./randomPercents";

export const initDiagramTrendWithAiPower = (id: string, realData: string[],futureData: string[], realNumbers: number[], predictGrow: number[], predictStable: number[], predictDrop: number[]) => {
    type EChartsOption = echarts.EChartsOption;
    // eslint-disable-next-line
    const chartDom = document.getElementById(id)!;
    const myChart = echarts.init(chartDom);
    let option: EChartsOption;
    const dates = [...realData, ...futureData];
    const percents = randomPercents();
    // eslint-disable-next-line prefer-const
    option = {
        title: {
            show: false,
        },
        color: ["#F1C40F","#B30000", "#5bbf83", "#a170f7"],
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow"
            },
            formatter: (params) => {
                // eslint-disable-next-line
                if((params as any[]).length === 3){
                    // eslint-disable-next-line
                    const inParams1: any = (params as any[])[0];
                    // eslint-disable-next-line
                    const inParams2: any = (params as any[])[1];
                    // eslint-disable-next-line
                    const inParams3: any = (params as any[])[2];
                    return `${inParams3.axisValueLabel}<br/><span style="color: ${inParams3.color}">${percents[0] + "%"}</span> : ${inParams3.value}<br/><span style="color: ${inParams1.color}">${percents[1]+ "%"}</span> : ${inParams1.value}<br/><span style="color: ${inParams2.color}">${percents[2] + "%"}</span> : ${inParams2.value}<br/>`;
                }else{
                    // eslint-disable-next-line
                    const lastInParams: any = (params as any[]).at(-1);
                    const axisValueLabel = lastInParams.axisValueLabel || "";
                    const value = lastInParams.value || "";
                    return `${axisValueLabel} : ${value}`;
                }
            }
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        xAxis: [
            {
                type: "category",
                boundaryGap: false,
                data: dates
            }
        ],
        yAxis: [
            {
                type: "value"
            }
        ],
        series: [
            {
                name: "Stable",
                type: "line",
                lineStyle: {
                    width: 0
                },
                showSymbol: false,
                areaStyle: {
                    opacity: 0.5,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#F1C40F"
                        },
                        {
                            offset: 1,
                            color: "#121212"
                        }
                    ])
                },
                data: predictStable,
                markArea: {
                    itemStyle: {
                        color: "#A9A9A9",
                        opacity: .3,
                    },
                    data: futureData.length ? [
                        [
                            {
                                name: "Future",
                                xAxis: realData[realData.length - 1]
                            },
                            {
                                xAxis: dates[dates.length - 1]
                            }
                        ]
                    ] : []
                }
            },
            {
                name: "Drop",
                type: "line",
                stack: "Total",
                lineStyle: {
                    width: 0
                },
                showSymbol: false,
                areaStyle: {
                    opacity: 0.8,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#B30000"
                        },
                        {
                            offset: 1,
                            color: "#121212"
                        }
                    ])
                },
                data: predictDrop
            },
            {
                name: "Grow",
                type: "line",
                lineStyle: {
                    width: 0
                },
                showSymbol: false,
                areaStyle: {
                    opacity: 0.4,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#5bbf83"
                        },
                        {
                            offset: 1,
                            color: "#121212"
                        }
                    ])
                },
                data: predictGrow
            },
            {
                name: "Total Asset Value",
                type: "line",
                lineStyle: {
                    width: 3,
                    color: "#a170f7"
                },
                showSymbol: false,
                areaStyle: {
                    opacity: 0.8,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#a170f7"
                        },
                        {
                            offset: 1,
                            color: "#121212"
                        }
                    ])
                },
                emphasis: {
                    focus: "self",
                },
                data: realNumbers
            },
        ]
    };
    
    option && myChart.setOption(option);
};
